module.exports = __webpack_public_path__ + "img/2-1.6f55cf13.svg";